import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl, FormArray, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/app-state';
import { PaybookService } from '../../../paybook/paybook.service';
import { ToastrService } from 'ngx-toastr';
import { ValidatorService } from '../../../core/service/app/validator.service';
import { CommerceService } from '../../../core/service/app/commerce.service';
import { CatalogueService } from 'app/core/service/core/cataloque.service';

@Component({
  selector: 'app-tpv-form',
  templateUrl: './tpv-form.component.html',
  styleUrls: ['./tpv-form.component.scss']
})
export class TpvFormComponent extends FormBaseComponent<any> implements OnInit {
  bankList$;
  affiliationList = [];
  user;
  showWidget = false;
  widgetID = 'sync_container_';
  bank = '';
  tipovistaBase = 'paybook';
  tipovista = '';
  @Input() id: number;
  //@Input() paybookID: string;
  @Input() titulo: string = '';
  tpvID : number = 0;
  idAdquirente: number = 0;
  idWizard: number = 0;
  connect: boolean = false;
  adquirentes = [];
  bancos = [];

  @Output() completo = new EventEmitter<boolean>();
  @Output() end = new EventEmitter<any>();
  @Output() onBlurAmount = new EventEmitter<number>();

  get isTerminado() {
    return this.form.value.terminado;
  }

  constructor(
    private store: Store<AppState>,
    private commerceService: CommerceService,
    private paybookService: PaybookService,
    private toastrService: ToastrService,
    private validatorService: ValidatorService,
    private catalogoService: CatalogueService
  ) {
    super();
    this.bankList$ = this.store.select(state => state.list.bank);
    /*this.affiliationList$ = this.store.select(
      state => state.list.membershipTime
    );*/
    this.store.subscribe(state => {
      this.user = state.user.data ? state.user.data.email : '';
    });
  }

  ngOnInit() {
    this.init();

    this.catalogoService.getAdquirentes().then(result => {
      this.adquirentes = result;
    });

    this.catalogoService.getBancos().then(result => {
      this.bancos = result;
    });

    this.catalogoService.getTiempoOperacion().then(result => {
      this.affiliationList = result;
    });

    this.form.statusChanges.subscribe(status=>{
      if (this.commerceService.info.finance != undefined) {
        let result = { ...this.commerceService.info.finance.tpvs[this.id] };
        this.tpvID = result.id;
        this.idWizard = this.commerceService.info.id;
        this.blurAmount();
      }
    });

    if(this.commerceService.info.finance != undefined)
    {
      let result = { ...this.commerceService.info.finance.tpvs[this.id] };
      if(this.tpvID == 0 && result.id != 0)
      {
        this.tpvID = result.id;
        this.idAdquirente = result.idAdquirente;
        this.form.patchValue({ id: this.tpvID });
        this.form.patchValue({ idAdquirente: this.idAdquirente });
      }
    }
  }

  cambiarvistaBase(tipo) {
    // if (tipo == 'paybook' && this.bank.length <= 0) {
    //   return;
    // }
    //this.form.patchValue({ opcion: tipo });
    if (this.tipovistaBase != tipo) {
      this.tipovistaBase = this.tipovistaBase == tipo ? '' : tipo;
      if (this.tipovistaBase == 'billing' || this.tipovistaBase == 'excel') {
        this.conectar();
      }
    }
  }
  conectar() {
    this.tipovista = this.tipovistaBase;
    this.connect = true;
    this.setBankID();
  }

  blurAmount() {
    this.onBlurAmount.emit(this.form.value.averageAmount || 0);
  }

  //56cf5728784806f72b8b456e
  //56fd304c78480623038b457b
  setBankID() {
    let value = '';
    switch (parseInt( this.form.get('bank').value , 10)) {
      case 1:
        value = '56cf5728784806f72b8b456b';
        break;
      case 2:
        value = '571175467848062d698b4568';
        break;
      case 3:
        value = '57f6dd8c78480602048b4567';
        break;
      case 4:
        value = '5719a71a7848060f038b4568';
        break;
      case 5:
        value = '56cf5728784806f72b8b456e';
        break;
      case 6:
        value = '56de2130784806d7028b4589';
        break;
      case 7:
        value = '572930c4784806060f8b456b';
        break;
      case 8:
        value = '5761abf97848065b038b4569';
        break;
      case 9:
        value = '57292023784806af038b458b';
        break;
      case 10:
        value = '57d1bccd784806b9488b456b';
        break;
      case 11:
        value = '56cf5728784806f72b8b456d';
        break;
      case 12:
        value = '574f16977848067c038b4593';
        break;
      case 13:
        value = '5760214578480648038b4584';
        break;
      case 14:
        value = '57ec3757784806dc038b4567';
        break;
      case 15:
        value = '57893e15784806f2218b457d';
        break;
      case 16:
        value = '57239fae78480601038b4567';
        break;
      case 17:
        value = '57239fae78480601038b4568';
        break;
      case 18:
        value = '56fd304c78480623038b457b';
        break;
      case 19:
        value = '583db66378480635468b456b';
        break;
      case 20:
        value = '56cf5728784806f72b8b456c';
        break;
      case 999:
        value = 'sat';
        break;
      default:
        value = '';
    }
    this.bank = value;
  }

  template() {

    this.form.addControl('averageAmount', new FormControl());
    this.form.addControl('bank', new FormControl());
    this.form.addControl('idAdquirente', new FormControl(0));
    this.form.addControl('idBanco', new FormControl(0));
    this.form.addControl('yearAffiliation', new FormControl(0));
    this.form.addControl('chargeBackAmount', new FormControl());
    this.form.addControl('cuentaClabe', new FormControl(''));
    this.form.addControl('cuentaBancaria', new FormControl(''));
    this.form.addControl('contractAffiliation', new FormControl('', [Validators.required]));
    this.form.addControl('idBillings', new FormControl(null));
    this.form.addControl('terminado', new FormControl(false));
    this.form.addControl('opcion', new FormControl(''));
    this.form.addControl('activado', new FormControl());
    this.form.addControl('verificado', new FormControl());

    this.form.addControl('transaccions', new FormArray( [ ]));



  }

  billingCompletado(event) {
    //this.onEnd(data.monto);
    this.completo.emit(event.status);
    //this.toastrService.success('Datos salvados correctamente.');
    //this.form.patchValue({ averageAmount: event.monto });
    //this.form.patchValue({ idBillings: event.ids });
  }

  transaccions(data)
  {
    //console.log('tpv list', data);
    if (data.lista) {
      while ((<FormArray>this.form.get('transaccions')).length !== 0) {
        (<FormArray>this.form.get('transaccions')).removeAt(0)
      }

      data.lista.map(item => {
        (<FormArray>this.form.get('transaccions')).push(
          new FormGroup({
            amount: new FormControl(item.amount),
            cargo: new FormControl(item.cargo || 0),
            abono: new FormControl(item.abono || 0),
            currency: new FormControl(item.currency),
            description: new FormControl(item.description),
            dt_disable: new FormControl(item.dt_disable),
            dt_refresh: new FormControl(item.dt_refresh),
            dt_transaction: new FormControl(item.dt_transaction),
            extra: new FormControl(item.extra),
            id_account: new FormControl(item.id_account),
            id_account_type: new FormControl(item.id_account_type),
            id_credential: new FormControl(item.id_credential),
            id_currency: new FormControl(item.id_currency),
            id_external: new FormControl(item.id_external),
            id_site: new FormControl(item.id_site),
            id_transaction: new FormControl(item.id_transaction),
            id_user: new FormControl(item.id_user),
            id_disable: new FormControl(item.id_disable),
            keywords: new FormControl(item.keywords),
            reference: new FormControl(item.reference),
            dateExcel: new FormControl(item.dateExcel)
          })
        );
      });
    } else {
      data.map(item => {
        (<FormArray>this.form.get('transaccions')).push(
          new FormGroup({
            amount: new FormControl(item.amount),
            cargo: new FormControl(item.cargo || 0),
            abono: new FormControl(item.abono || 0),
            currency: new FormControl(item.currency),
            description: new FormControl(item.description),
            dt_disable: new FormControl(item.dt_disable),
            dt_refresh: new FormControl(item.dt_refresh),
            dt_transaction: new FormControl(item.dt_transaction),
            extra: new FormControl(item.extra),
            id_account: new FormControl(item.id_account),
            id_account_type: new FormControl(item.id_account_type),
            id_credential: new FormControl(item.id_credential),
            id_currency: new FormControl(item.id_currency),
            id_external: new FormControl(item.id_external),
            id_site: new FormControl(item.id_site),
            id_transaction: new FormControl(item.id_transaction),
            id_user: new FormControl(item.id_user),
            id_disable: new FormControl(item.id_disable),
            keywords: new FormControl(item.keywords),
            reference: new FormControl(item.reference),
            dateExcel: new FormControl(item.dateExcel)
          })
        );
      });
    }

    //this.form.patchValue({ averageAmount: data.suma });
    //this.toastrService.success('Datos salvados correctamente.');
    //this.onEnd(data.suma)
  }

  onEnd(monto = 0) {
    //this.tipovista = '';
    //this.form.patchValue({ terminado: true });
    this.end.emit(monto);
  }


}

/*
56cf5728784806f72b8b456e Banorte Personal
56cf5728784806f72b8b456b Personal
56de2130784806d7028b4589 AfirmeNet
56cf5728784806f72b8b456c BancaNet Personal
56cf5728784806f72b8b456f CIEC
56cf5728784806f72b8b456d eBanRegio
56fd304c78480623038b457b Banorte en su empresa
571175467848062d698b4568 BancaNet Empresarial
5719a71a7848060f038b4568 Banca Personal
57239fae78480601038b4567 Corporativo
57292023784806af038b458b Banco Azteca
572930c4784806060f8b456b American Express
5731fb37784806a6118b4571 SuperNET Particulares
5739cc3b7848066b028b4573 ScotiaWeb
57239fae78480601038b4568 Empresas
574f16977848067c038b4593 InbuRed
5760214578480648038b4584 Invex
5761abf97848065b038b4569 BanCoppel Personal
5777e4bbc320d546ba6e014d Inbursa Personal
57893e15784806f2218b457d Multivanet
57accfcd784806f4038b4567 IXE empresa
57d1bccd784806b9488b456b Banco Famsa
57ec3757784806dc038b4567 Liverpool
57f6dd8c78480602048b4567 Santander Empresas
57fed73d7848060b038b4586 CFE
582a05fb78480655628b45a1 Movistar
580fa37978480600038b4571 Telcel
57ffc01a7848060a038b45b1 Telmex
582f8a21784806eb348b4581 AT&T
583db66378480635468b456b BanBajio Personas
58543125784806c3298b4572 SAT Declara
58db325f056f293bed3ebfb1 Scotiabank Empresas
5903d9c5056f2905e37d4951 Banco Azteca Empresas
*/



// WEBPACK FOOTER //
// ./src/app/form/form/tpv-form/tpv-form.component.ts